<div class="row text-center">

  <div class="col-md-8">
    <h3 class="text-calendar">{{ viewDate | calendarDate:(view + 'ViewTitle'):'es' }}</h3>
  </div>
  <div class="col-md-4">
    <div class="btn-group btns-calendar">
      <div class="btn btn-primary text-btns-calendar" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">Anterior</div>
      <div class="btn btn-outline-secondary text-btns-calendar" mwlCalendarToday [(viewDate)]="viewDate" >Actual</div>
      <div class="btn btn-primary text-btns-calendar" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">Siguiente</div>
    </div>
  </div>
</div>
<br />
<div [ngSwitch]="view" style="margin: 0px 30px 30px 30px;">
  <mwl-calendar-month-view
    *ngSwitchCase="CalendarView.Month"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [activeDayIsOpen]="activeDayIsOpen"
    [locale]="locale"
    (eventClicked)="openModal(capacitacionModal, 'edit', $event.event)"

    weekStartsOn="1"
    (dayClicked)="dayClicked($event.day)"

    (eventTimesChanged)="eventTimesChanged($event)" >
  </mwl-calendar-month-view>
  <ng-template #capacitacionModal let-modal>
    <app-capacitacion-modal [modal]="modal" [capacitacion]="datosCapacitacion" [mode]="creationMode" [categoriesWithFocos]="categoriesWithFocos"
                            [workersSelected]="workersSelected" [enfoques]="enfoques" [ejecutoresWithRelatores]="ejecutoresWithRelatores" [zonas]="zonas" (save)="onSave()"
                            (accept)="onSaveAccept()">
    </app-capacitacion-modal>
  </ng-template>


</div>
